import {fromJS} from 'immutable';
import dieselReducer from '../../decorators/DieselReducer';
import {ToastTypes} from '../actions/toast.actions';

export const DEFAULT_STATE = fromJS([]);

export const toastsReducer = (state = DEFAULT_STATE, action) => {
    const {payload} = action;

    switch (action.type) {
        case ToastTypes.SHOW_TOAST:
            return state.push(fromJS(payload));
        case ToastTypes.DISMISS_TOAST:
            return state.filter(item => item.get('id') !== payload.id);
        default:
            return state;
    }
};
export default toastsReducer;

dieselReducer('toasts', toastsReducer);
